<form [formGroup]="form">
  <div class="inputs">
    <label>Password </label>
    <div caInputContainer [onLightBackground]="onLightBackground">
      <input
        name="New Password Input 1"
        caInput
        [type]="showPassword ? 'text' : 'password'"
        autocomplete="new-password"
        formControlName="newPassword"
        (blur)="onTouched()"
        (input)="onChange($event.target.value)"
        />
      <button
        class="show-password"
        mat-icon-button
        color="primary"
        aria-label="Show password"
        (click)="showPassword = !showPassword"
        type="button"
        >
        <mat-icon>{{
          showPassword ? "visibility" : "visibility_off"
        }}</mat-icon>
      </button>
    </div>
    <div
      [ngClass]="'strengthIndicator passwordStrength_' + (score$ | async)"
    ></div>
    <p class="strengthLabel min-h-4">{{ score$ | async | passwordStrength }}</p>

    <label>Confirm password </label>
    <div caInputContainer [onLightBackground]="onLightBackground">
      <input
        name="New Password Input 2"
        caInput
        [type]="showConfirmPassword ? 'text' : 'password'"
        autocomplete="new-password"
        formControlName="confirmPassword"
        (input)="onTouched()"
        />
      <button
        class="show-password"
        mat-icon-button
        color="primary"
        aria-label="Show password"
        (click)="showConfirmPassword = !showConfirmPassword"
        type="button"
        >
        <mat-icon>{{
          showConfirmPassword ? "visibility" : "visibility_off"
        }}</mat-icon>
      </button>
    </div>
  </div>
  <div class="errors mt-1 flex flex-col gap-1 text-sm">
    <div
      id="lengthError"
      [class.error]="form.errors?.minLength && form.controls.newPassword.dirty"
      [class.success]="!form.errors?.minLength"
      class="flex flex-row justify-start gap-1 items-center"
      >
      @if (form.errors?.minLength) {
        <mat-icon inline="true">cancel</mat-icon>
      }
      @if (!form.errors?.minLength) {
        <mat-icon inline="true"
          >check_circle</mat-icon
          >
        }
        <p>Password is at least 8 characters long</p>
      </div>
      <div
        id="mismatchError"
      [class.error]="
        form.errors?.passwordMismatch && form.controls.confirmPassword.dirty
      "
        [class.success]="!form.errors?.passwordMismatch"
        class="flex flex-row justify-start gap-1 items-center"
        >
        @if (form.errors?.passwordMismatch) {
          <mat-icon inline="true"
            >cancel</mat-icon
            >
          }
          @if (!form.errors?.passwordMismatch) {
            <mat-icon inline="true"
              >check_circle</mat-icon
              >
            }
            <p>Password and Confirm fields match</p>
          </div>
        </div>
      </form>
